import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassSubCategory extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassSubCategory'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      subCategoryId: null,
      rating: 0,
      title: null,
      description: null,
      goalRating: 0.0,
      goalDescription: null,
      categoryId: null,
      isRequired: false,
      isEnabled: true,
      compassCategoryId: null,
      goalCollectionSubCategoryId: null,
    }
  }
}
const servicePath = 'compass-sub-categories'
const servicePlugin = makeServicePlugin({
  Model: CompassSubCategory,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
